import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

function NewOrgUser({ display, setUsers, setAlert }) {
  const [orgInviteEmail, setOrgInviteEmail] = useState("");
  const buttonArrow = <div class="btn-arrow"></div>;

  let orgInviteDisplayClass = display ? "flex" : "none";

  const inviteSend = (email) => {
    // Send ajax request to add org user

    let nonce = document.getElementById("_wpnonce").value;
    document.body.style.cursor = "wait";

    let data_val = {
      email: email,
    };

    fetch("/wp-admin/admin-ajax.php", {
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-WP-Nonce": nonce, // here you used the wrong name
      },
      method: "POST",
      body: new URLSearchParams({
        action: "invite_organizational_member",
        data: JSON.stringify(data_val),
      }),
    })
      .then((response) => response.json())

      .then((response) => {
        if (response.success) {

          setAlert( (old) => ({...old, show:true, message:response.message, isError: false}) );

          setUsers((users) => [
            ...users,
            { id: response.id, share_user_id: response.user_id, email: email },
          ]);
          // Append to users list
        } else {
          if(response.message){
            setAlert( (old) => ({...old, show:true, message:response.message, isError: true}) );
          }
          else{
            setAlert( (old) => ({...old, show:true, message:"", isError: true}) );

          }
        }

        document.body.style.cursor = "default";
      })
      .catch(function (error) {
        document.body.style.cursor = "default";
        setAlert( (old) => ({...old, show:true, message:"", isError: true} ));
      });

    setOrgInviteEmail("");
  };

  return (
    <Row
      className="share-org-invite"
      style={{ display: orgInviteDisplayClass }}
    >
      <Col className="share-org-invite__field">
        <Form.Control
          type="email"
          value={orgInviteEmail}
          placeholder="Enter Email Address..."
          onChange={(e) => setOrgInviteEmail(e.target.value)}
        />
      </Col>
      <Col className="share-org-invite__button">
        <Button onClick={() => inviteSend(orgInviteEmail)}>
          Add User{buttonArrow}
        </Button>
      </Col>
    </Row>
  );
}

export default NewOrgUser;
